var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-guide-view"},[_c('div',{staticClass:"exam-guide-view__top"},[_c('bread-crumbs'),_vm._v(" "),_c('div',{staticClass:"exam-guide-view__side"},[_c('div',{staticClass:"calculator"},[_c('Calculator')],1)])],1),_vm._v(" "),_c('exam-search'),_vm._v(" "),_c('featured-exams')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }